export { default } from './TiraFirmes';
